import { CARD_IMAGE_HOVER_ZOOM } from 'constants/cardImageZoom';

export const SCREENSHOT_TIER_WIDTHS = {
  thumb: 400,
  medium: 800,
  full: Infinity,
};

const TIER_ORDER = ['thumb', 'medium', 'full'];
const UPGRADE_HYSTERESIS = 1.25;

export function getDevicePixelRatio() {
  if (typeof window === 'undefined') return 1;
  return window.devicePixelRatio || 1;
}

export function getRequiredScreenshotWidth({
  layoutWidth,
  viewZoom = 1,
  isHovered = false,
  dpr = getDevicePixelRatio(),
  nativeWidth,
}) {
  const parsedLayout = Number(layoutWidth);
  const parsedZoom = Number(viewZoom);
  const safeLayout = Number.isFinite(parsedLayout) && parsedLayout > 0 ? parsedLayout : 300;
  const safeZoom = Number.isFinite(parsedZoom) && parsedZoom > 0 ? parsedZoom : 1;
  const hoverFactor = isHovered ? CARD_IMAGE_HOVER_ZOOM : 1;
  let required = safeLayout * safeZoom * hoverFactor * dpr;

  const parsedNative = Number(nativeWidth);
  if (Number.isFinite(parsedNative) && parsedNative > 0) {
    required = Math.min(required, parsedNative);
  }

  return required;
}

export function getScreenshotTiers(action, pinnedComment = null) {
  const source = action?.elementScreenshotUrl ? action : pinnedComment;
  const full = source?.elementScreenshotUrl || action?.elementScreenshotUrl || null;
  if (!full) {
    return { thumb: null, medium: null, full: null };
  }

  const thumb = source?.elementScreenshotThumbUrl || action?.elementScreenshotThumbUrl || full;
  const medium = source?.elementScreenshotMediumUrl || action?.elementScreenshotMediumUrl || full;

  return { thumb, medium, full };
}

export function getTierMaxWidth(tierName) {
  return SCREENSHOT_TIER_WIDTHS[tierName] ?? SCREENSHOT_TIER_WIDTHS.full;
}

export function pickScreenshotTier(requiredWidth, tiers, loadedTierWidth = 0) {
  if (!tiers?.full) return { tier: 'full', src: null, maxWidth: SCREENSHOT_TIER_WIDTHS.full };

  if (loadedTierWidth > 0 && loadedTierWidth >= requiredWidth) {
    for (const tierName of TIER_ORDER) {
      const maxWidth = getTierMaxWidth(tierName);
      const src = tiers[tierName];
      if (!src) continue;
      if (maxWidth >= loadedTierWidth) {
        return { tier: tierName, src, maxWidth };
      }
    }
  }

  const threshold = Math.max(loadedTierWidth * UPGRADE_HYSTERESIS, 0);

  for (const tierName of TIER_ORDER) {
    const maxWidth = getTierMaxWidth(tierName);
    const src = tiers[tierName];
    if (!src) continue;
    if (requiredWidth <= maxWidth || tierName === 'full') {
      if (maxWidth > threshold || tierName === 'full') {
        return { tier: tierName, src, maxWidth };
      }
    }
  }

  return { tier: 'full', src: tiers.full, maxWidth: SCREENSHOT_TIER_WIDTHS.full };
}

export function compareTierWidth(a, b) {
  return getTierMaxWidth(a) - getTierMaxWidth(b);
}
